var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopbarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4674 0L0 19.9791H3.68913L10.4674 7.17825L17.2678 19.9791H20.9569L10.4674 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9355 0.331116H24.802V19.9991H27.9355V0.331116Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02296 19.9813H8.20068L8.75628 18.9146L9.40076 17.6923L9.88968 16.7366L10.2675 16.0033L10.4675 15.581L10.8897 16.3811L11.4009 17.3811L11.6009 17.7589L11.8898 18.3367L12.2676 19.0479L12.7565 19.9813H11.9343H9.02296Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopbarLogo);
export default __webpack_public_path__ + "static/media/topbar-logo.2c950ce19294e6d991fbfaef009925fe.svg";
export { ForwardRef as ReactComponent };